import React from "react";
import { Box, Typography, Container } from "@mui/material";

const Dashboard = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ py: 4 }}>
        <Typography variant="h1" gutterBottom>
          Dashboard
        </Typography>
        <Typography variant="body1">
          Welcome to your dashboard. This is where you'll see your overview and
          analytics.
        </Typography>
      </Box>
    </Container>
  );
};

export default Dashboard;
